<!-- 调查项管理界面 -->
<template>
  <div class="survey-manage-box survey-scroll">
    <div class="left-box">
      <el-scrollbar style="height: 100%">
        <!-- 头部区域 -->
        <h3 class="title-box">
          调查项分类
          <img :src="imgUrl" style="width: 22px;height: 22px;position: absolute;right: 15px;cursor: pointer;"
            @click="addSurveyItemClassify" />
        </h3>
        <!-- 分类内容区域 :class="item.selected ? 'selected-item-box' : ''"-->
        <div class="content-box">
          <div v-for="(item, index) in surveyItemClassifyArr" :key="index" :class="[
            index != surveyItemClassifyArr.length - 1
              ? 'content-border-item'
              : 'content-item',
            item.selected ? 'content-selected-item' : '',
          ]" @click="selectedSurveyItemClassifyItem(item)">
            <div>{{ item.label }}</div>
            <!-- 修改、删除按钮 -->
            <div>
              <img :src="editImgUrl" style="width: 18px; height: 18px; cursor: pointer"
                @click="editSurveyItemClassify(item)" />
              <img :src="deleteImgUrl" style="
                  width: 18px;
                  height: 18px;
                  cursor: pointer;
                  margin: 0 10px;
                " @click="deleteSurveyItemClassify(item)" />
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div class="right-box access-record-container">
      <!--主页面 -->
      <div class="flex-row" style="height: 100%">
        <div class="flex-auto flex-valign" style="overflow: hidden">
          <!-- 右侧表格 -->
          <div class="section-main_table">
            <ioc-table ref="accessTab" :data="tableData" :option="tableOption" :page="page" @row-cancle="closeDialog"
              @search-change="searchResult" @search-reset="resetQuery" @current-change="selectPage"
              @size-change="changeSize" @selection-change="handleSelectionChange">
              <!-- 表格搜索条件 自定义 -->
              <!-- 类型 -->
              <!-- <template slot="search_type">
                <div>
                  <el-select v-model="searchParams.type" placeholder="请选择">
                    <el-option v-for="item in surveyTypeOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </template> -->
              <!-- 状态-->
              <!-- <template slot="search_status">
                <div>
                  <el-select v-model="searchParams.status" placeholder="请选择">
                    <el-option v-for="item in surveyStatusOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </template> -->
              <!-- 上方按钮 -->
              <template slot="menuLeft">
                <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus"
                  @click="handleAddCar">
                  新增
                </el-button>
                <el-button size="small" icon="el-icon-delete" class="iss-operation-button" @click="handelDelSurvey"
                  :disabled="!checkedSurveyIds.length ? true : false">
                  批量删除
                </el-button>
              </template>
              <!-- 自定义操作列 -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" icon="iconfont icon-xiugai"
                    @click="handleEdit(scope.row, scope.index)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" icon="iconfont icon-shanchu"
                    @click="handleDel(scope.row, scope.index)"></el-button>
                </el-tooltip>
              </template>
              <!-- 表格列 自定义 -->
              <!-- <template slot="trafficFileCode" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.trafficFileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
                @click="
                  showViewer(getImgPath(scope.row.trafficFileCode), $event)
                "
              />
            </template> -->
              <!-- 车牌号点击可以跳转详情页面 -->
              <!-- <template slot="plateCode" slot-scope="scope">
                <span style="cursor: pointer" @click="handleView(scope.row, scope.index)">{{ scope.row.plateCode }}</span>
              </template> -->
              <!-- 查看详情表单 自定义 -->
              <!-- <template slot="trafficFileCodeView" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.trafficFileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
                @click="
                  showViewer(getImgPath(scope.row.trafficFileCode), $event)
                "
              />
            </template> -->
            </ioc-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/修改 调查项分类 -->
    <el-dialog v-ops:width="450" :close-on-click-modal="false" :title="surveyClassifyTitle" :visible.sync="showDialog">
      <el-form ref="surveyClassifyForm" :rules="surveyClassifyRules" :model="surveyClassifyForm" label-width="120px">
        <el-form-item label="调查项分类名称" prop="name">
          <el-input type="text" maxlength="30" placeholder="请输入调查项分类名称" v-model="surveyClassifyForm.name"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSurveyClassifyForm"> 取消</el-button>
        <el-button type="primary" @click="saveSurveyClassifyForm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增/修改 -->
    <appPanel :width="700" class="app-panel" :isExpand="showAddOrEditPanel" @cancel="handleCloseAddOrEditPanel"
      :title="title">
      <!-- 内容区域 -->
      <div class="survey-box">
        <!-- 上方表单 -->
        <el-form style="width: 99%; height: 165px" :inline="true" :model="surveyFromInfo" :rules="surveyFromRule"
          ref="surveyFrom" label-width="120px" label-position="right" label-suffix=" ：">
          <el-row>
            <el-col :span="24">
              <el-form-item label="调查项标题" prop="title" style="width: 94%">
                <el-input v-model="surveyFromInfo.title" placeholder="请输入调查项标题">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="调查项状态" prop="status" style="width: 94%" class="survey-type-box">
                <el-radio-group v-model="surveyFromInfo.status">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="2">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="调查项类型" prop="type" style="width: 94%">
                <el-select v-model="surveyFromInfo.type" placeholder="请选择" @change="handleSelectChange">
                  <el-option v-for="item in surveyItemArr" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 下方表格 -->
        <div style="height: calc(100% - 165px); width: 99%" v-if="surveyFromInfo.type !== 3">
          <el-table :data="itemTableData" :stripe="false" size="mini" :border="false" :highlight-current-row="false"
            height="100%" :header-cell-style="headerStyle">
            <el-table-column align="center" label="选项文字">
              <el-table-column prop="title">
                <template slot-scope="scope">
                  <div>
                    <el-select v-model="scope.row.title" placeholder="请选择" style="width: 150px">
                      <el-option v-for="item in optionItemOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </el-select>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="description">
                <template slot-scope="scope">
                  <div>
                    <el-input v-model="scope.row.description" placeholder="选项描述" style="width: 150px; margin-left: 5px" />
                    <i class="soc iconVideoPlus" @click="handleAddTableItem(scope.row)"
                      style="margin-left: 5px; cursor: pointer" />
                    <i v-if="scope.$index !== 0" class="soc iconDelete"
                      @click="handleDeleteTableItem(scope.row, scope.$index)" style="margin-left: 5px; cursor: pointer" />
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <!-- 调查项类型 -->
            <el-table-column prop="type" label="默认" width="120" show-overflow-tooltip header-align="center"
              align="center">

              <template slot-scope="scope">
                <!-- 多选 -->
                <el-checkbox v-model="surveyFromInfo.typeValue" :label="scope.$index" v-if="surveyFromInfo.type === 2">
                  &nbsp;
                </el-checkbox>
                <!-- 单选 -->
                <el-radio v-model="surveyFromInfo.typeValue" :label="scope.$index" v-if="surveyFromInfo.type === 1">
                  &nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="table-empty">
                <img src="@/common/assets/images/empty.svg" />
                <p>{{ $t("base.label.empty") }}</p>
              </div>
            </template>
          </el-table>
        </div>
      </div>

      <!-- 按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAddOrEditPanel" type="info" :loading="subLoading">
          取消
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSaveAddOrEditPanel">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Bus } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/surveyManageTable";

export default {
  components: {
    appPanel,
  },
  data() {
    return {
      imgUrl: require("../img/add.png"),
      editImgUrl: require("../img/edit.png"),
      deleteImgUrl: require("../img/delete.png"),
      // 调查项分类 信息
      selectedSurveyItemClassify: -1,
      surveyItemClassifyArr: [],
      surveyClassifyTitle: "",
      showDialog: false,
      surveyClassifyForm: {
        id: -1,
        name: "",
      },
      surveyClassifyRules: {
        name: [
          {
            required: true,
            message: "请输入调查项分类名称",
            trigger: ["blur", "change"],
          },
        ],
      },
      surveyItemArr: [
        { label: "单选", value: 1 },
        { label: "多选", value: 2 },
        { label: "文本框", value: 3 },
      ],
      form: {},
      showPanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      itemTableData: [
        {
          title: "",
          description: ""
        },
      ],
      searchParams: {},
      // 选择的SurveyId
      checkedSurveyIds: [],
      // 新增/修改表格
      subLoading: false,
      title: "",
      showAddOrEditPanel: false,
      surveyFromInfo: {
        id: -1,
        categoryId: 0,
        title: "",
        status: 2,
        type: 1,
        typeValue: '',
        // 表格选项内容
        list: [],
      },
      surveyFromRule: {
        title: [
          {
            required: true,
            message: "请输入调查项标题",
            trigger: ["blur", "change"],
          },
        ],
        status: [
          {
            required: true,
            message: "请选择调查项状态",
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "请选择调查项类型",
            trigger: ["blur", "change"],
          },
        ],
      },
      // 下拉选项信息
      surveyStatusOptions: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 2,
          label: "禁用",
        },
      ],
      surveyTypeOptions: [
        {
          value: 1,
          label: "单选",
        },
        {
          value: 2,
          label: "多选",
        },
        {
          value: 3,
          label: "文本框",
        },
      ],
      participantOptions: [],
      surveyItemOptions: [],
      optionItemOptions: [],
    };
  },
  mounted() {
    // this.initChartData();
    // window.onresize = () => {
    //   this.bwRateChart.resize();
    // };
    // 获取调查项分类数据
    this.initSurveyClassifyList();
    // this.getSurveyList();
    // 初始化表格下拉框选项信息
    this.initSelectOptionList();
  },
  beforeDestroy() {
    // window.onresize = null;
  },
  methods: {
    handleSelectChange(val) {
      if (val === 1) {
        this.surveyFromInfo.typeValue = ''
      } else if (val === 2) {
        this.surveyFromInfo.typeValue = []
      } else {
        this.surveyFromInfo.typeValue = null
      }
    },
    headerStyle({ row, column, rowIndex, columnIndex }) {
      // 让第一行的第一个元素占2列
      if (rowIndex == 0) {
        row[0].colSpan = 2;
      }
      if (rowIndex == 1) {
        row[0].colSpan = 0;
        row[1].colSpan = 0;
        if (columnIndex == 0 || columnIndex == 1) {
          return {
            display: "none",
          };
        }
      }
    },
    initSelectOptionList() {
      this.optionItemOptions = [
        { label: "A", value: "A" },
        { label: "B", value: "B" },
        { label: "C", value: "C" },
        { label: "D", value: "D" },
        { label: "E", value: "E" },
        { label: "F", value: "F" },
        { label: "G", value: "G" },
        { label: "H", value: "H" },
      ];
    },
    // 初始化“调查项 分类”数据
    initSurveyClassifyList() {
      this.$fetch(api.surveyManage.queryQuestionCategoryList, {}).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          if (response.returnObj.length > 0) {
            this.surveyItemClassifyArr = response.returnObj.map(
              (item, index) => {
                let newItem = {
                  label: item.name,
                  selected: index == 0 ? true : false,
                  ...item
                };
                return newItem;
              }
            );
            this.selectedSurveyItemClassify = this.surveyItemClassifyArr[0].id;
            // 获取分类下的调查项信息
            this.getSurveyList();
          } else {
            this.surveyItemClassifyArr = [];
          }
        }
      );
    },
    // 添加调查项分类
    addSurveyItemClassify() {
      this.surveyClassifyTitle = "新增调查项分类";
      this.surveyClassifyForm.id = undefined;
      this.showDialog = true;
    },
    // 修改调查项分类
    editSurveyItemClassify(pItem) {
      // console.log("---修改调查项分类--index:--", pItem);
      this.surveyClassifyTitle = "修改调查项分类";
      this.surveyClassifyForm = pItem;
      this.showDialog = true;
    },
    // 删除调查项分类 --- 接口联调400
    deleteSurveyItemClassify(pItem) {
      // console.log("---删除调查项分类--pItem:--", pItem);
      //
      this.$confirm("您确定删除该调查项分类信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.surveyManage.deleteQuestionCategory, {
          id: pItem.id,
        }).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.initSurveyClassifyList();
        });
      });
    },
    /** 改变条目状态 */
    selectedSurveyItemClassifyItem(pItem) {
      this.surveyItemClassifyArr.forEach((item) => {
        if (pItem.id == item.id) {
          item.selected = true;
          this.selectedSurveyItemClassify = item.id;
        } else {
          item.selected = false;
        }
      });
      this.getSurveyList();
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 获取调查项列表
    getSurveyList() {
      const params = {};
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;

      params.status = Number(this.searchParams.status);
      params.type = Number(this.searchParams.type);
      params.title = this.searchParams.title;
      params.categoryId = this.selectedSurveyItemClassify;

      this.$fetch(api.surveyManage.queryQuestionList, params).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.tableData = response.returnObj.list
          this.page.total = response.returnObj ? response.returnObj.total : 0;
          this.$refs.accessTab.selectClear();
        }
      );
    },
    // 详情操作
    handleView(row, index) {
      // this.showPanel = true;
      // this.form = row;
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() {
    },

    // 查询按钮事件
    searchResult(param) {
      // console.log("---查询--param:--", param);
      this.searchParams = param;
      // console.log("---查询--this.searchParams:--", this.searchParams);
      this.page.currentPage = 1;
      this.getSurveyList();
    },
    // 重置按钮
    resetQuery() {
      // console.log("---重置--this.searchParams:--", this.searchParams);
      this.getSurveyList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getSurveyList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getSurveyList();
    },
    handleSelectionChange(items) {
      // console.log("---select--items:--", items);

      if (!items || !items.length) {
        this.checkedSurveyIds = [];
      } else {
        this.checkedSurveyIds = items.map((item) => {
          return item.id;
        });
      }
      // console.log("----this.checkedSurveyIds:---", this.checkedSurveyIds);
    },
    // 新增操作
    handleAddCar() {
      this.title = "新增调查项";
      this.surveyFromInfo.id = undefined;
      this.showAddOrEditPanel = true;
    },
    // 批量删除操作
    handelDelSurvey() {
      // console.log("批量删除操作");
      this.$confirm("您确定批量删除所选择的调查项吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(
          api.surveyManage.deleteQuestion,
          this.checkedSurveyIds
        ).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getSurveyList();
        });
      });
    },
    // 编辑操作
    handleEdit(row, index) {
      console.log("修改调查项", row);
      this.title = "修改调查项";
      this.showAddOrEditPanel = true;
      this.surveyFromInfo = row;
      if (this.surveyFromInfo.type === 1) {
        this.surveyFromInfo.typeValue = +this.surveyFromInfo.typeValue
      }
      if (this.surveyFromInfo.type === 2) {
        this.surveyFromInfo.typeValue = this.surveyFromInfo.typeValue === '' ? [] : this.surveyFromInfo.typeValue.split(',').map(Number)
      }
      // if (this.surveyFromInfo.list.length === 0) {
      //   this.itemTableData = this.surveyFromInfo.list.concat(this.itemTableData);
      // }
      this.itemTableData = this.surveyFromInfo.list.concat(this.itemTableData);
    },

    // 单个删除操作
    handleDel(row) {
      // console.log("单个删除操作");

      this.$confirm("您确定删除该调查项信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.surveyManage.deleteQuestion, [row.id]).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getSurveyList();
          }
        );
      });
    },
    // 关闭新增/修改 弹窗
    handleCloseAddOrEditPanel() {
      // TODO处理from表单取消校验操作
      this.handleRestForm();
      this.getSurveyList();
      this.showAddOrEditPanel = false;
    },
    // 保存新增/修改 弹窗
    handleSaveAddOrEditPanel() {
      // TODO处理from表单校验操作
      // 新增/修改成功后的操作
      this.$refs.surveyFrom.validate((valid) => {
        if (valid) {
          // 处理list
          this.surveyFromInfo.list = this.itemTableData.filter(
            (item) => item.title && item.description
          );
          let map = {};
          this.surveyFromInfo.list.forEach((item) => {
            map[item.title] = item;
          });
          this.surveyFromInfo.list = Object.values(map);

          let params = { ...this.surveyFromInfo };
          params.categoryId = this.selectedSurveyItemClassify;
          if (this.surveyFromInfo.type === 1) {
            params.typeValue = params.typeValue + ''
          }
          if (this.surveyFromInfo.type === 2) {
            params.typeValue = params.typeValue.length > 0 ? params.typeValue.join(',') : ''
          }
          if (params.id) {
            // 修改
            this.$fetch(api.surveyManage.updateQuestion, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.msgContent);
                } else {
                  this.$message.success("修改成功！");
                }
                // 关闭弹窗
                this.showAddOrEditPanel = false;
                this.handleRestForm();
                // 刷新列表数据
                this.getSurveyList();
                // this.getQuestionList();
              }
            );
          } else {
            // 新增
            this.$fetch(api.surveyManage.addQuestion, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.msgContent);
                } else {
                  this.$message.success("新增成功！");
                }
                // 关闭弹窗
                this.showAddOrEditPanel = false;
                this.handleRestForm();
                // 刷新列表数据
                this.getSurveyList();
                // this.getQuestionList();
              }
            );
          }
        } else {
          return false;
        }
      });
    },
    // 调查项分类 相关操作
    cancelSurveyClassifyForm() {
      this.handleRestSurveyClassifyForm();
      this.initSurveyClassifyList();
      this.showDialog = false;
    },
    saveSurveyClassifyForm() {
      this.$refs.surveyClassifyForm.validate((valid) => {
        if (valid) {
          let params = { ...this.surveyClassifyForm };
          if (params.id) {
            // 修改
            this.$fetch(api.surveyManage.updateQuestionCategory, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.msgContent);
                } else {
                  this.$message.success("修改成功！");
                }
                // 关闭弹窗
                this.showDialog = false;
                this.handleRestSurveyClassifyForm();
                // 刷新列表数据
                this.initSurveyClassifyList();
              }
            );
          } else {
            // 新增
            this.$fetch(api.surveyManage.addQuestionCategory, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.msgContent);
                } else {
                  this.$message.success("新增成功！");
                }
                // 关闭弹窗
                this.showDialog = false;
                this.handleRestSurveyClassifyForm();
                // 刷新列表数据
                this.initSurveyClassifyList();
              }
            );
          }
        } else {
          return false;
        }
      });
    },
    // 重置表单操作
    handleRestForm() {
      this.surveyFromInfo.categoryId = 0;
      this.surveyFromInfo.title = "";
      this.surveyFromInfo.type = 1;
      this.surveyFromInfo.typeValue = '';
      this.surveyFromInfo.status = 2;
      this.surveyFromInfo.list = [];
      this.surveyFromInfo.id = undefined;
      this.itemTableData = [
        {
          title: "",
          description: ""
        },
      ];
      this.$nextTick(() => {
        this.$refs["surveyFrom"].clearValidate();
      })
    },
    handleRestSurveyClassifyForm() {
      this.surveyClassifyForm.id = -1;
      this.surveyClassifyForm.name = "";
      this.$nextTick(() => {
        this.$refs["surveyClassifyForm"].clearValidate();
      })
    },
    //
    handleAddTableItem(row) {
      this.itemTableData.push({
        title: "",
        description: ""
      });
    },
    handleDeleteTableItem(row, index) {
      this.itemTableData.splice(index, 1);
      if (this.surveyFromInfo.type === 1 && this.surveyFromInfo.typeValue === index) {
        this.surveyFromInfo.typeValue = ''
      }
      if (this.surveyFromInfo.type === 2 && this.surveyFromInfo.typeValue.indexOf(index) !== -1) {
        this.surveyFromInfo.typeValue.splice(this.surveyFromInfo.typeValue.indexOf(index), 1);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.survey-manage-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .left-box {
    width: 0px;
    flex: 1;
    height: 100%;
    @include set_theme_color(background-color, left-menu-bg-color);
    margin-right: 10px;
    padding: 10px 16px;

    .title-box {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      // color: #fff;
      color: #000000;
      border-left-width: 3px;
      border-left-style: solid;
      padding-left: 10px;
      margin-left: 10px;
      border-left-color: #407aee;
      position: relative;
    }

    .content-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;

      .content-item {
        width: 95%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #407aee;
      }

      :active {
        background: #407aee;
      }

      .content-selected-item {
        background: #407aee;
      }

      .content-border-item {
        width: 95%;
        height: 41px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid white;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #407aee;
      }

      :active {
        background: #407aee;
      }

      .content-selected-item {
        background: #407aee;
      }
    }
  }

  .access-record-container {
    width: 100%;
    height: 100%;

    .el-table__fixed-right-patch {
      display: none;
    }

    .el-dialog {

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
      }
    }
  }

  .right-box {
    width: 0px;
    flex: 4;
    height: 100%;
  }

  .survey-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 75vh;

    ::v-deep .el-form-item__content {
      width: 80%;
    }

    ::v-deep .el-select {
      width: 100%;
    }

    .survey-type-box {
      display: flex;

      ::v-deep .el-form-item__content {
        display: flex;
      }

      .desc {
        width: 155px;
        margin-left: 5px;
      }

      ::v-deep .el-select {
        width: 0px;
        flex: 1;
      }
    }

    ::v-deep .el-range-editor--small.el-input__inner {
      width: 95%;
    }
  }

  // ::v-deep .el-table thead th {
  //   background-color: #343d55;
  //   border: 0px solid;
  // }
  ::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #2e86e8 !important;
  }
}
</style>

<style>
.survey-scroll .el-table__body-wrapper {
  height: 100%;
  overflow-y: auto;
}
</style>